import BaseModule from './BaseModule.js';

class QuoteAccessToken extends BaseModule {
  async paginate({ page, per_page, term, sort_by, sort_direction }) {
    return await this.get(`back-office/quote-access-tokens`, {
      params: { page, per_page, term, sort_by, sort_direction },
    });
  }

  async fetch(id) {
    return await this.get(`/back-office/quote-access-tokens/${id}`);
  }

  async create(data) {
    return await this.post(`/back-office/quote-access-tokens`, data);
  }

  async update(data) {
    return await this.patch(`/back-office/quote-access-tokens/${data.id}`, data);
  }

  async remove(id) {
    return await this.delete(`/back-office/quote-access-tokens/${id}`);
  }

  async fetchLimit(id) {
    return await this.get(`/back-office/quote-access-tokens/limit/${id}`);
  }

  async balance() {
    return await this.get(`/back-office/quote-access-tokens/balance/provider`);
  }

  async checkProviders() {
    return await this.get(`/back-office/quote-access-tokens/providers/check`);
  }

  async fetchQuotes() {
    return await this.get(`/back-office/quote-access-tokens/quotes_providers`);
  }
}

export default QuoteAccessToken;
